import { useState } from 'react';
import ModalShell from './ModalShell';
import { useTranslation } from '../../hooks/useTranslation';

const AVAILABLE_ROLES = ['readonly', 'user', 'admin', 'root'];
const initialFormState = {
  username: '',
  password: '',
  full_name: '',
  email: '',
  phone_number: '',
  address: '',
  telegram_chat_id: '',
  telegram_id: '',
  telegram_name: '',
  roles: ['readonly'],
};

const CreateUserModal = ({ onClose, onSubmit }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState(initialFormState);
  const [validated, setValidated] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleRoleToggle = (role) => {
    setFormData((prev) => ({
      ...prev,
      roles: prev.roles.includes(role)
        ? prev.roles.filter((r) => r !== role)
        : [...prev.roles, role],
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setValidated(true);
    if (!formData.username || !formData.password) return;
    onSubmit(formData);
  };

  return (
    <ModalShell title={t('users.addUser')} size="lg" onClose={onClose}>
      <form onSubmit={handleSubmit} noValidate className={validated ? 'was-validated' : ''}>
        <div className="modal-body">
          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label">{t('users.usernameRequired')} <span className="text-danger">*</span></label>
              <input type="text" className="form-control" name="username" value={formData.username} onChange={handleChange} required />
              <div className="invalid-feedback">{t('users.usernamePasswordRequired')}</div>
            </div>
            <div className="col-md-6">
              <label className="form-label">{t('users.passwordRequired')} <span className="text-danger">*</span></label>
              <input type="password" className="form-control" name="password" value={formData.password} onChange={handleChange} required minLength={1} />
              <div className="invalid-feedback">{t('users.usernamePasswordRequired')}</div>
            </div>
            <div className="col-md-6">
              <label className="form-label">{t('users.fullNameLabel')}</label>
              <input type="text" className="form-control" name="full_name" value={formData.full_name} onChange={handleChange} />
            </div>
            <div className="col-md-6">
              <label className="form-label">{t('users.emailLabel')}</label>
              <input type="email" className="form-control" name="email" value={formData.email} onChange={handleChange} />
            </div>
            <div className="col-md-6">
              <label className="form-label">{t('users.phoneLabel')}</label>
              <input type="text" className="form-control" name="phone_number" value={formData.phone_number} onChange={handleChange} />
            </div>
            <div className="col-md-6">
              <label className="form-label">{t('users.telegramChatIdLabel')}</label>
              <input type="text" className="form-control" name="telegram_chat_id" value={formData.telegram_chat_id} onChange={handleChange} />
            </div>
            <div className="col-md-6">
              <label className="form-label">{t('users.telegramIdLabel')}</label>
              <input type="text" className="form-control" name="telegram_id" value={formData.telegram_id} onChange={handleChange} />
            </div>
            <div className="col-md-6">
              <label className="form-label">{t('users.telegramNameLabel')}</label>
              <input type="text" className="form-control" name="telegram_name" value={formData.telegram_name} onChange={handleChange} />
            </div>
            <div className="col-12">
              <label className="form-label">{t('users.addressLabel')}</label>
              <input type="text" className="form-control" name="address" value={formData.address} onChange={handleChange} />
            </div>
            <div className="col-12">
              <label className="form-label d-block">{t('users.initialRoles')}</label>
              {AVAILABLE_ROLES.map((role) => (
                <div className="form-check form-check-inline" key={role}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id={`new-role-${role}`}
                    checked={formData.roles.includes(role)}
                    onChange={() => handleRoleToggle(role)}
                  />
                  <label className="form-check-label" htmlFor={`new-role-${role}`}>{role}</label>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={onClose}>{t('common.cancel')}</button>
          <button type="submit" className="btn btn-primary">{t('common.create')}</button>
        </div>
      </form>
    </ModalShell>
  );
};

export default CreateUserModal;
